/**
 * A small top-of-page banner shown only when the public bundle is rendered
 * inside the admin's preview iframe (`?preview=1`). The banner exists so
 * editors never mistake a preview render for the live site.
 *
 * Phase K+4. No-op outside preview mode (returns null).
 */

import { useIsPreview } from '../lib/content';

export function PreviewBanner() {
  const isPreview = useIsPreview();
  if (!isPreview) return null;
  return (
    <div
      data-testid="preview-banner"
      role="status"
      aria-live="polite"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        background: '#0f172a',
        color: '#fef3c7',
        textAlign: 'center',
        fontSize: '11px',
        letterSpacing: '0.25em',
        textTransform: 'uppercase',
        padding: '6px 12px',
        fontWeight: 700,
        borderBottom: '2px solid #fbbf24',
      }}
    >
      Preview mode &middot; submissions disabled &middot; live admin push
    </div>
  );
}
